import './App.css';
import Chatbot from 'react-chatbot-kit';
import 'react-chatbot-kit/build/main.css';
import config from './bot/config.js';
import MessageParser from './bot/MessageParser.js';
import ActionProvider from './bot/ActionProvider.js';
import React, { useEffect, useState } from 'react';
import { getChatbot, getEntreprise, getChatById } from "./api/service";
import { createChatBotMessage } from 'react-chatbot-kit';
import './i18.js';
import { useTranslation } from 'react-i18next';

function App() {
    const [botConfig, setBotConfig] = useState(null); // Initialiser avec null
    const [loading, setLoading] = useState(true); // État de chargement
    const [chatbotId, setChatBotId] = useState(null); // État de chargement
    const [chatbotData, setChatBotData] = useState();
    
    const { t, i18n } = useTranslation();

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang); // Change the language dynamically
        localStorage.setItem('lang', lang); // Save the language in localStorage
    };

    // Sauvegarde des messages, modules et autres données du chatbot dans localStorage sous l'objet 'chatbots'
    const saveMessages = (messages) => {
        const chatbotsData = JSON.parse(localStorage.getItem('chatbots')) || {};
        if (chatbotId) {
            // Conserver tous les éléments sauf les chat_messages actuels
            chatbotsData[chatbotId] = {
                ...chatbotsData[chatbotId],
                chat_messages: messages // Mettre à jour uniquement les messages
            };
            localStorage.setItem('chatbots', JSON.stringify(chatbotsData));
        }
    };

    // Chargement des messages depuis le localStorage
    const loadMessages = () => {
        const chatbotsData = JSON.parse(localStorage.getItem('chatbots')) || {};
        return chatbotId && chatbotsData[chatbotId] ? chatbotsData[chatbotId].chat_messages : [];
    };

    useEffect(() => {
        const getIdChat = async () => {
            try {
                let chat
                const chat_bot_id = window.location.href.includes('chatbot_id=') 
                    ? window.location.href.split('chatbot_id=')[1].split('&')[0] 
                    : '';

                setChatBotId(chat_bot_id);
                localStorage.setItem("chatbot_id_active", chat_bot_id);

                const chatbotsData = JSON.parse(localStorage.getItem('chatbots')) || {};
                const chat_id_active = chatbotsData[chat_bot_id]?.chat_id || null
                if(chat_id_active){
                    chat = await getChatById(chat_id_active) 
                }

                let lang = 'fr';
                if(chat_bot_id.toString() === '76') {
                    lang = 'en';
                }
                if(localStorage.getItem('lang')){
                    lang = localStorage.getItem('lang');
                }
                if(window.location.search.includes('lang=')){
                    lang = window.location.search.split('lang=')[1].split('&')[0];
                }
                changeLanguage(lang);

                if(window.location.search.includes('token=')){
                    localStorage.setItem('user_token', window.location.search.split('token=')[1].split('&')[0]);
                }

                if (chatbotsData[chat_bot_id] && chat && chat?.data?.status !== 'end') {
                    // Si le chatbot existe déjà, récupérer les données depuis l'API et conserver les messages existants
                    const chatbotFromAPI = await getChatbot(chat_bot_id);
                    
                    if (chatbotFromAPI && chatbotFromAPI.data) {
                        const chatbotData = chatbotFromAPI.data;
                        const existingMessages = chatbotsData[chat_bot_id].chat_messages; // Conserver les messages existants
                      
                        // Mettre à jour la config avec les nouvelles données API
                        setBotConfig({
                            ...config,
                            initialMessages: existingMessages, // Garder les messages actuels
                            modules: chatbotData.modules,
                            entreprise: chatbotsData[chat_bot_id].entreprise,
                        });

                        // Mettre à jour les autres éléments dans localStorage sauf les messages
                        chatbotsData[chat_bot_id] = {
                            ...chatbotsData[chat_bot_id], // Garder les messages actuels
                            id: chatbotData.id,
                            modules: chatbotData.modules,
                            messages: chatbotData.messages, // Messages du chatbot (intro, outro, etc.)
                        };
                        localStorage.setItem('chatbots', JSON.stringify(chatbotsData));
                    }
                } else {
                    // Si le chatbot n'existe pas dans le localStorage, récupérer les données via l'API et stocker tout
                    const data = await getChatbot(chat_bot_id);
                    if (data && data.data && data.data.id && data.data.modules && data.data.messages) {
                        const intro = data.data.messages.intro || t('introMessage');

                        const entreprise = await getEntreprise(data.data.entreprise_id);
                        if (!window.location.search.includes('lang=') && !localStorage.getItem('lang')) {
                            changeLanguage(entreprise.data.contact.lang || lang);
                        }
                        const entrepriseData = entreprise && entreprise.data && entreprise.data.nom
                            ? { id: entreprise.data.id, nom: entreprise.data.nom }
                            : {};

                        const categories = data?.data?.categories?.filter(item => item.active) || [];     

                        // Mettez à jour la configuration du chatbot avec les nouvelles données
                        setBotConfig({
                            ...config,
                            botName: entrepriseData.nom,
                            initialMessages: [
                                createChatBotMessage(intro),
                                (chat_bot_id.toString() === '70' || chat_bot_id.toString() === '73' || chat_bot_id.toString() === '76') ? '' : (categories.length > 0
                                    ? createChatBotMessage(t('categoryMessage'), {withAvatar: true, widget: 'choices', payload: { content: categories, color: data.data.modules.chatbot.color } })
                                    : createChatBotMessage(t('helpMessage'), {withAvatar : true})) // Message d'intro alternatif
                            ],
                        });
                        
                        // Stocker toutes les données dans localStorage
                        chatbotsData[chat_bot_id] = {
                            id: data.data.id,
                            chat_messages: [
                                createChatBotMessage(intro),
                                (chat_bot_id.toString() === '70' || chat_bot_id.toString() === '73' || chat_bot_id.toString() === '76') ? '' : (categories.length > 0
                                    ? createChatBotMessage(t('categoryMessage'), {   withAvatar: true, widget: 'choices', payload: { content: categories, color: data.data.modules.chatbot.color } })
                                    : createChatBotMessage(t('helpMessage'), {withAvatar : true})), // Message d'intro alternatif
                            ],
                            entreprise: entrepriseData,
                            modules: data.data.modules,
                            messages: data.data.messages, // Messages du chatbot (par exemple intro, outro, etc.)
                        };

                        delete chatbotsData[chat_bot_id]['chat_id']
                        
                        localStorage.setItem('chatbots', JSON.stringify(chatbotsData));
                    }
                }

                setChatBotData(chatbotsData[chat_bot_id])
            } catch (error) {
                console.error(error);
            } finally {
                await new Promise((r,re) => setTimeout(r, 1000));
                setLoading(false); // Fin du chargement
            }
        };

        getIdChat();
    }, []);

    useEffect(() => {
        const btn = document.querySelector('.react-chatbot-kit-chat-btn-send');
        if (!loading && btn) {
            btn.innerHTML = `
                <svg class="react-chatbot-kit-chat-btn-send-icon" xmlns="http://www.w3.org/2000/svg" width="71" height="70" viewBox="0 0 71 70">
                    <g> <path d="M26.4168 54.9786C25.9023 55.48 25.2958 55.6696 24.5973 55.5476C23.8987 55.4256 23.4105 55.0289 23.1326 54.3574L19.5683 45.7441L32.2821 36.4845L16.7429 38.9163L13.1786 30.303C12.9007 29.6316 12.9658 29.0058 13.3739 28.4259C13.7819 27.8459 14.3451 27.5516 15.0635 27.5428L48.5104 27.7651C49.4097 27.791 50.0255 28.2056 50.3579 29.0088C50.6903 29.8121 50.5465 30.5381 49.9264 31.1869L26.4168 54.9786Z"/>
                    </g>
                </svg>`;
            btn.querySelector('svg').style.fill = chatbotData?.modules?.chatbot?.color;
        }
    }, [loading]);

    return (
        <div>
            {loading && <div style={{margin: '50px auto'}}><span className={'loading-points'}><span></span></span></div>}
            <div style={{opacity: (loading ? '0' : '1')}}>
                {botConfig && (
                    <Chatbot
                        config={botConfig}
                        headerText={chatbotData.entreprise.nom}
                        messageParser={MessageParser}
                        actionProvider={ActionProvider}
                        saveMessages={saveMessages}
                        messageHistory={loadMessages()}
                        placeholderText={t('writeMessage')}
                        validator={(msg) => msg.length > 0 && msg.length < 401}
                    />
                )}
            </div>
        </div>
    );
}

export default App;
